
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    imports: [],
    templateUrl: './typography.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './typography.scss'
})
export class Typography {}
